import store from '@/store'
import { computed } from '@vue/composition-api'

const useFullscreen = () => {

  const isFullscreen = computed(() => store.state.events.fullscreen)
  const toggleFullscreen = async (value?: boolean) => {
    await store.dispatch.events.toggleFullscreen(value ?? !isFullscreen.value)
  }

  return {
    isFullscreen,
    toggleFullscreen
  }
}

export default useFullscreen
